<template>
  <ConfirmationPopup
    ref="confirmationPopup"
    type="warning"
    :closeable="true"
    title="Укладення полісів тимчасово заблоковано"
    message=""
    :controls="controls"
    :max-width="500"
    @close="onClose"
  >
    <p class="blocked-orders__message">
      Будь ласка, зверніться до технічної підтримки для консультації або проходження реєстрації в НБУ.
    </p>
    <div class="blocked-orders__contacts">
      <p class="blocked-orders__contact-item">support@ukasko.com.ua</p>
      <p class="blocked-orders__contact-item">+380 50 305 55 07</p>
    </div>
  </ConfirmationPopup>
</template>

<script>
import { ConfirmationPopup } from '@/shared/ui/popup';

export default {
  components: { ConfirmationPopup },
  computed: {
    controls() {
      return [{ type: 'default', label: 'Закрити', event: 'close' }];
    },
  },
  methods: {
    open() {
      this.$refs.confirmationPopup.open();
    },

    close() {
      this.$refs.confirmationPopup?.close();
    },

    onClose() {
      this.$emit('closed');
    },
  },
};
</script>

<style scoped lang="scss">
.blocked-orders {
  &__message {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 16px;
  }

  &__contacts {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__contact-item {
    font-size: 14px;
    font-weight: 500;
    margin: 0;
  }
}
</style>
